import { FC, SVGProps } from 'react';

const LockOutlinedIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  color = '#2d2d2d',
  size = 18,
  ...props
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" {...props} fill="none">
      <g opacity="0.5">
        <path
          d="M10.9491 6.29864V4.86731C10.9491 3.19198 9.59041 1.83328 7.91508 1.83328C6.23974 1.82598 4.87574 3.17798 4.86841 4.85398V4.86731V6.29864"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4555 14.1666H5.3615C3.9655 14.1666 2.8335 13.0352 2.8335 11.6386V8.77922C2.8335 7.38255 3.9655 6.25122 5.3615 6.25122H10.4555C11.8515 6.25122 12.9835 7.38255 12.9835 8.77922V11.6386C12.9835 13.0352 11.8515 14.1666 10.4555 14.1666Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.90869 9.46851V10.9492"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export default LockOutlinedIcon;
